import { GB, ID } from "country-flag-icons/react/3x2";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";

// Icon-sized toggle: shows the active flag, one tap swaps English <-> Indonesian.
// Kept to an icon so it still fits the phone Topbar next to the menu button and
// the role badge; the 40px touch target comes from size-10 below md.
export default function LangSwitch() {
  const { lang, setLang, t } = useI18n();
  const next = lang === "en" ? "id" : "en";
  const Flag = lang === "en" ? GB : ID;
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      className="size-10 shrink-0 md:size-8"
      aria-label={t("lang.switchTo", { lang: t(next === "id" ? "lang.id" : "lang.en") })}
      title={t(lang === "id" ? "lang.id" : "lang.en")}
      onClick={() => setLang(next)}
    >
      {/* inline size: the Button variant forces size-4 on bare svg children, which would square the 3x2 flag. */}
      <Flag className="rounded-sm" style={{ width: 24, height: 16 }} aria-hidden />
    </Button>
  );
}
